import axios from "axios";
import { API_URL } from "@helpers";

export const getFile = (url: string) => {
    return axios.get(`${API_URL}/${url}`, { responseType: "blob" });
};
